import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import TemplateDashboard from '../TemplateDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import TemplatePageImpl from './TemplatePageImpl';

export default function TemplatePage() {
    const dispatch = useDispatch();
    const { templateList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < TemplatePageImpl />
    )

}